/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable no-unused-vars */
/**

* © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile

* Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United

* States and/or other countries.

*/

import React from 'react';
import { useHistory, Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { useDispatch, useSelector } from 'react-redux';

import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import {
  handleScrollToEvent,
  redirectURLLink,
} from '../../../SharedModules/CommonUtilities/commonUtilities';
import {
  openHelpModuleUrl,
  openReleaseNotesUrl,
} from '../../../SharedModules/CommonUtilities/safeWindowOpen';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  row: {
    direction: 'row',
    justify: 'center',
    alignItems: 'flex-start',
    spacing: 2,
  },
  line: {
    border: '1px solid #000000',
    marginTop: 0,
  },
  heading: {
    paddingTop: '10px',
    color: '#274463',
    fontWeight: 650,
    fontSize: '16px',
  },
  svg: {
    float: 'left',
    paddingRight: '8px',
  },
  grid: {
    padding: '6px',
  },
}));

function SITEMAP() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  const handleRedirectURL = (URL, name) => {
    redirectURLLink(URL, name, history, dispatch);
  };
  const changeRoute = (routeName) => {
    if (routeName === 'Release Notes') {
      openReleaseNotesUrl();
    } else {
      openHelpModuleUrl(routeName);
    }
  };

  return (
    <>
      <div className="tabs-container">
        <div className="tBillPanel custom-check">
          <div className="paneldevider-line">
            <div className="custom-panel">
              <CustomSeparator parent1="CMdS Rebate Site Map" />
            </div>
            <div className="p-3 sitemap-container">
              <Grid container className={classes.row}>
                <Grid item xs className={classes.grid}>
                  {loginState?.menuItems
                    ?.filter((x) => {
                      return (
                        x.name === 'Invoice' ||
                        x.name === 'CMS' ||
                        x.name === 'Tasks' ||
                        x.name === 'Maintain' ||
                        x.name === 'Help'
                      );
                    })
                    .map((item) => {
                      return (
                        <>
                          <label className={classes.heading}>{item.name}</label>
                          <hr className={classes.line} />
                          {item.name === 'Help' ? (
                            <>
                              <div>
                                <SVGComponent
                                  iconName="polygon5"
                                  classNames={classes.svg}
                                />
                                <Link
                                  to="#"
                                  role="button"
                                  style={{ color: '#004A99' }}
                                  onClick={() => {
                                    changeRoute('Default.htm');
                                  }}
                                  className="a site-map ml-2"
                                  title="Help Index"
                                >
                                  Help Index
                                </Link>
                              </div>
                              <div>
                                <SVGComponent
                                  iconName="polygon5"
                                  classNames={classes.svg}
                                />
                                <Link
                                  to="#"
                                  role="button"
                                  style={{ color: '#004A99' }}
                                  onClick={() => {
                                    changeRoute('Release Notes');
                                  }}
                                  className="a site-map ml-2"
                                  title="Release Notes"
                                >
                                  Release Notes
                                </Link>
                              </div>
                              <div>
                                <SVGComponent
                                  iconName="polygon5"
                                  classNames={classes.svg}
                                />
                                <Link
                                  to="#"
                                  role="button"
                                  style={{ color: '#004A99' }}
                                  onClick={() => {
                                    handleRedirectURL('/about', 'About');
                                  }}
                                  className="a site-map ml-2"
                                  title="About"
                                >
                                  About
                                </Link>
                              </div>
                            </>
                          ) : (
                            item.children?.map((prop) => {
                              return (
                                <div>
                                  <SVGComponent
                                    iconName="polygon5"
                                    classNames={classes.svg}
                                  />
                                  <Link
                                    to="#"
                                    role="button"
                                    style={{ color: '#004A99' }}
                                    onClick={() => {
                                      handleRedirectURL(prop.url, prop.name);
                                    }}
                                    className="a site-map ml-2"
                                    title={prop.name}
                                  >
                                    {prop.name}
                                  </Link>
                                </div>
                              );
                            })
                          )}
                        </>
                      );
                    })}
                </Grid>
                <Grid item xs className={classes.grid}>
                  {loginState?.menuItems
                    ?.filter((x) => {
                      return (
                        x.name === 'Display' ||
                        x.name === 'Research' ||
                        x.name === 'Summary Reports' ||
                        x.name === 'Detail Reports'
                      );
                    })
                    .map((item) => {
                      return (
                        <>
                          <label className={classes.heading}>{item.name}</label>
                          <hr className={classes.line} />
                          {item.children?.map((prop) => {
                            return (
                              <div>
                                <SVGComponent
                                  iconName="polygon5"
                                  classNames={classes.svg}
                                />
                                <Link
                                  to="#"
                                  role="button"
                                  style={{ color: '#004A99' }}
                                  onClick={() => {
                                    handleRedirectURL(prop.url, prop.name);
                                  }}
                                  className="a site-map ml-2"
                                  title={prop.name}
                                >
                                  {prop.name}
                                </Link>
                              </div>
                            );
                          })}
                        </>
                      );
                    })}
                </Grid>
                <Grid item xs className={classes.grid}>
                  {loginState?.menuItems
                    ?.filter((x) => {
                      return x.name === 'State Reports' || x.name === 'System';
                    })
                    .map((item) => {
                      return (
                        <>
                          <label className={classes.heading}>{item.name}</label>
                          <hr className={classes.line} />
                          {item.children?.map((prop) => {
                            return (
                              <div>
                                <SVGComponent
                                  iconName="polygon5"
                                  classNames={classes.svg}
                                />
                                <Link
                                  to="#"
                                  role="button"
                                  style={{ color: '#004A99' }}
                                  onClick={() => {
                                    handleRedirectURL(prop.url, prop.name);
                                  }}
                                  className="a site-map ml-2"
                                  title={prop.name}
                                >
                                  {prop.name}
                                </Link>
                              </div>
                            );
                          })}
                        </>
                      );
                    })}
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default withRouter(SITEMAP);
